module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.494772d6d0c523d0a544.js");
};